import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button, Stack, Typography } from '@mui/joy';
import { TextInputField } from '../FormElements/TextInputField';

interface DroneSerialNumberFormProps {
  onSubmit: (serial: string) => void;
  loading?: boolean;
}

export default function DroneSerialNumberForm({ onSubmit, loading }: DroneSerialNumberFormProps) {
  const { t } = useTranslation();
  const [serial, setSerial] = useState('');
  const [touched, setTouched] = useState(false);

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setTouched(true);
    if (serial.trim()) {
      onSubmit(serial.trim());
    }
  };

  const hasError = touched && !serial.trim();

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ maxWidth: 400, mx: 'auto', mt: 4 }}>
      <Stack spacing={2}>
        <Typography level="h3">{t('register_drone.enter_serial')}</Typography>
        <TextInputField
          label={t('drone.eid')}
          name="droneSerial"
          value={serial}
          onChange={e => setSerial(e.target.value)}
          required
          error={hasError ? t('register_drone.serial_required') : ''}
        />
        <Button type="submit" loading={loading} variant="solid">
          {t('register_drone.submit')}
        </Button>
      </Stack>
    </Box>
  );
}
